import { render, staticRenderFns } from "./CarSeriesComponents.vue?vue&type=template&id=2d48ffd7&scoped=true"
import script from "./CarSeriesComponents.vue?vue&type=script&lang=js"
export * from "./CarSeriesComponents.vue?vue&type=script&lang=js"
import style0 from "./CarSeriesComponents.vue?vue&type=style&index=0&id=2d48ffd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d48ffd7",
  null
  
)

export default component.exports